import { render } from "./FooTer.vue?vue&type=template&id=ff05dbf0&scoped=true"
import script from "./FooTer.vue?vue&type=script&lang=js"
export * from "./FooTer.vue?vue&type=script&lang=js"

import "./FooTer.vue?vue&type=style&index=0&id=ff05dbf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff05dbf0"]])

export default __exports__